import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import man from "../../plus image.jpeg";
import "./monthly-invoice.css";
import "./wholesale-kido.css";
import "./invoice-detail-kido.css";
import EmptyState from "../../../common/EmptyState";
import KidoLoader from "../../../common/KidoLoader";
import { uploadImage } from "../../../../firebase/firebase.utils";
import {
  updateSourcingRedux,
  getSingleSourcingRedux,
  deleteSourcingProductRedux,
} from "../../../../actions/index";
import { Search, FileText, ArrowLeft, Plus, User, Globe, Calendar, Edit3, Trash2, X } from "react-feather";
import { sendNotifications } from "../../../../firebase/fcmRestApi";
export class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      singleLot: null,
      expenseObj: null,
      loader: false,
      type: "upload",
      checkedValues: [],
      checkedValues2: [],
      id: "",
      name: "",
      description: "",
      searchFor: "",
      productObj: null,
      loading: false,
      imageUrl: man,
      file: "",
      type: "",
      customer: "",
      customerUid: "",
      cursor: -1,
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      productsArray: [
        {
          id: new Date().getTime(),
          imageUrl: man,
          productName: "",
          quantity: "",
          details: "",
        },
      ],
      productName: "",
      quantity: "",
      details: "",
      amount: "",
      orderStatus: "",
      trackingNo: "",
      orderStore: "",
      orderId: "",
    };
  }

  componentDidMount = async () => {
    const { invoiceId } = this.props.match.params;
    const { getSingleSourcingRedux } = this.props;
    await getSingleSourcingRedux(invoiceId);
  };

  componentWillReceiveProps = async (nextProps) => {
    const { invoiceId, getSingleSourcingRedux } = this.props.match.params;
    const invoiceId2 = nextProps.match.params.invoiceId;

    if (invoiceId !== invoiceId2) {
      await getSingleSourcingRedux(invoiceId);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  _handleImgChange = async (e, i) => {
    e.preventDefault();
    const { currentAdmin } = this.props;
    let product = this.state.productsArray[i];
    console.log(this.state.productsArray);
    console.log(i);
    console.log(product);
    let reader = new FileReader();
    let file = e.target.files[0];
    const { imageUrl } = this.state;

    reader.onloadend = () => {
      // imageUrl = reader.result;
      this.setState({
        file: file,
        imageUrl,
      });
    };
    if (file) {
      console.log(i);
      this.setState({ loading: true });
      reader.readAsDataURL(file);
      const imgUrl = await uploadImage(file, "zapaiProducts");

      this.setState(
        {
          imageUrl: imgUrl,
          productsArray: this.state.productsArray.map((product2) => {
            console.log(product);
            if (product2.id === product.id) {
              return { ...product2, imageUrl: imgUrl };
            } else {
              return product2;
            }
          }),
        },
        () => {
          console.log(this.state.productsArray);
        }
      );

      this.setState({ loading: false });
    }
  };

  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  handleSubmit = async () => {
    const { sourcingObj } = this.props;
    if (!sourcingObj) {
      alert("Invoice is still loading, please try again in a moment");
      return;
    }

    let invalidProduct = this.state.productsArray.find(
      (product) => product.productName == "" || product.quantity == "",
    );
    if (invalidProduct) {
      alert("You must fill in the product name and quantity");
      return;
    }
    const newProducts = this.state.productsArray.map((product) => ({
      ...product,
      imageUrl: product.imageUrl === man ? "" : product.imageUrl,
    }));
    await this.props.updateSourcingRedux({
      ...sourcingObj,
      productsArray:
        sourcingObj.productsArray && sourcingObj.productsArray.length > 0
          ? [...sourcingObj.productsArray, ...newProducts]
          : newProducts,
    });

    this.setState({
      productsArray: [
        {
          id: new Date().getTime(),
          imageUrl: man,
          productName: "",
          quantity: "",
          details: "",
        },
      ],
    });
  };
  handleUpdate = async (sourcingObj, product) => {
    await this.props.updateSourcingRedux({
      ...sourcingObj,
      productsArray: sourcingObj.productsArray.map((product2) => {
        if (product2.id == product.id) {
          return {
            ...product2,
            productName: this.state.productName,
            quantity: this.state.quantity,
            details: this.state.details,
            amount: this.state.amount,
            orderStatus: this.state.orderStatus,
            trackingNo: this.state.trackingNo,
            orderStore: this.state.orderStore,
            orderId: this.state.orderId,
          };
        } else {
          return product2;
        }
      }),
    });

    this.setState({
      productsArray: [
        {
          id: new Date().getTime(),
          imageUrl: man,
          productName: "",
          quantity: "",
          details: "",
        },
      ],
    });
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  render() {
    const { productObj } = this.state;
    const { currentAdmin, sourcingObj } = this.props;
    const { invoiceId } = this.props.match.params;

    let totalOrder = 0;
    if (
      sourcingObj &&
      sourcingObj.productsArray &&
      sourcingObj.productsArray.length > 0
    ) {
      sourcingObj.productsArray.map((product) => {
        if (product.amount) {
          totalOrder += parseInt(product.amount);
        }
      });
    }
    const products = (sourcingObj && sourcingObj.productsArray) || [];
    return (
      <Fragment>
        <div className="kd-ws">
        <Breadcrumb
          title={sourcingObj && sourcingObj.customer ? sourcingObj.customer : invoiceId}
          parent="Wholesale Management/Order"
        />
        <div className="container-fluid">
          <section className="card kd-orders-card">
            <div className="kd-ord-top">
              <div className="kd-ord-title">
                <span className="kd-ord-title-tile kd-st--butter" aria-hidden="true">
                  <FileText size={20} />
                </span>
                <div>
                  <h2>
                    Invoice <span className="kd-inv-id">#{invoiceId}</span>
                  </h2>
                  <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                    <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                  </svg>
                </div>
              </div>
              <div className="kd-ws-actions">
                {sourcingObj && sourcingObj.month && (
                  <Link
                    to={`${process.env.PUBLIC_URL}/business-consultancy/sourcing/invoice/${sourcingObj.month}`}
                    className="btn btn-light"
                  >
                    <ArrowLeft size={15} aria-hidden="true" />
                    {sourcingObj.month.replace(",", " ")}
                  </Link>
                )}
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#personalInfoModal"
                  onClick={() => {
                    this.setState({});
                  }}
                >
                  <Plus size={15} aria-hidden="true" />
                  Add products
                </button>
              </div>
            </div>

            <div className="kd-ws-body">
              {!sourcingObj ? (
                <div className="kd-inv-loading">
                  <KidoLoader inline label="Loading invoice" />
                </div>
              ) : (
                <div className="kd-inv-slip">
                  <div className="kd-inv-head">
                    <div className="kd-inv-to">
                      <span className="kd-inv-label">Billed to</span>
                      <strong className="kd-inv-customer">
                        {sourcingObj.customer || "-"}
                      </strong>
                      <div className="kd-inv-meta">
                        {sourcingObj.agent && (
                          <span>
                            <User size={12} aria-hidden="true" />
                            {sourcingObj.agent}
                          </span>
                        )}
                        {sourcingObj.country && (
                          <span>
                            <Globe size={12} aria-hidden="true" />
                            {sourcingObj.country}
                          </span>
                        )}
                        {sourcingObj.date && (
                          <span>
                            <Calendar size={12} aria-hidden="true" />
                            {sourcingObj.date}
                          </span>
                        )}
                      </div>
                      <div className="kd-inv-badges">
                        {sourcingObj.invoiceStatus && (
                          <span
                            className={`kd-status-badge kd-st--${
                              sourcingObj.invoiceStatus === "Paid"
                                ? "mint"
                                : sourcingObj.invoiceStatus === "Not Paid"
                                ? "rose"
                                : "butter"
                            }`}
                          >
                            <span className="kd-status-dot" />
                            {sourcingObj.invoiceStatus}
                          </span>
                        )}
                        {sourcingObj.sourcingStatus && (
                          <span className="kd-status-badge kd-st--sky">
                            <span className="kd-status-dot" />
                            {sourcingObj.sourcingStatus}
                          </span>
                        )}
                      </div>
                    </div>
                    <dl className="kd-inv-money">
                      <div className="is-main">
                        <dt>Invoice bill</dt>
                        <dd>
                          <span className="kd-price-sticker">
                            ৳ {sourcingObj.totalBill || 0}
                          </span>
                        </dd>
                      </div>
                      <div>
                        <dt>Total ordered</dt>
                        <dd>৳ {totalOrder}</dd>
                      </div>
                      <div>
                        <dt>Products</dt>
                        <dd>{products.length}</dd>
                      </div>
                    </dl>
                  </div>

                  {products.length === 0 ? (
                    <EmptyState hint="Use “Add products” to start the packing list.">
                      No products on this invoice yet.
                    </EmptyState>
                  ) : (
                    <ul className="kd-inv-lines" id="basicScenario">
                      {products.map((product, index) => {
                        const ordered = product.orderStatus == "Ordered";
                        return (
                          <li key={index} className="kd-inv-line" style={{ "--i": Math.min(index, 12) }}>
                            <span className="kd-inv-num">{index + 1}</span>
                            <a
                              className="kd-inv-img"
                              href={product.imageUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={product.imageUrl ? product.imageUrl : man}
                                alt=""
                              />
                            </a>
                            <div className="kd-inv-what">
                              <strong>{product.productName}</strong>
                              {product.details && <small>{product.details}</small>}
                              <span className={`kd-status-badge kd-st--${ordered ? "mint" : "rose"}`}>
                                <span className="kd-status-dot" />
                                {product.orderStatus ? product.orderStatus : "Not Ordered"}
                              </span>
                            </div>
                            <dl className="kd-inv-facts">
                              <div>
                                <dt>Quantity</dt>
                                <dd>{product.quantity || "—"}</dd>
                              </div>
                              <div>
                                <dt>Order store</dt>
                                <dd>{product.orderStore || "—"}</dd>
                              </div>
                              <div>
                                <dt>Order ID</dt>
                                <dd>{product.orderId || "—"}</dd>
                              </div>
                              <div>
                                <dt>Tracking no</dt>
                                <dd>{product.trackingNo || "—"}</dd>
                              </div>
                            </dl>
                            <span className="kd-inv-price">
                              {product.amount ? (
                                <span className="kd-price-sticker">৳ {product.amount}</span>
                              ) : (
                                <span className="kd-muted">No price</span>
                              )}
                            </span>
                            <span className="kd-inv-acts">
                              <button
                                type="button"
                                className="kd-icon-btn kd-act--mint"
                                aria-label="Edit product"
                                title="Edit product"
                                data-toggle="modal"
                                data-target="#editProductModal"
                                onClick={() => {
                                  this.setState({
                                    productObj: product,
                                    productName: product.productName,
                                    quantity: product.quantity,
                                    details: product.details,
                                    amount: product.amount
                                      ? product.amount
                                      : "",
                                    orderStatus: product.orderStatus
                                      ? product.orderStatus
                                      : "Not Ordered",
                                    trackingNo: product.trackingNo
                                      ? product.trackingNo
                                      : "",
                                    orderStore: product.orderStore
                                      ? product.orderStore
                                      : "",
                                    orderId: product.orderId
                                      ? product.orderId
                                      : "",
                                  });
                                }}
                              >
                                <Edit3 size={14} aria-hidden="true" />
                              </button>
                              <button
                                type="button"
                                className="kd-icon-btn kd-act--rose"
                                aria-label="Delete product"
                                title="Delete product"
                                data-toggle="modal"
                                data-target="#deleteExpenseModal"
                                onClick={() => {
                                  this.setState({
                                    productObj: product,
                                  });
                                }}
                              >
                                <Trash2 size={14} aria-hidden="true" />
                              </button>
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              )}
            </div>
          </section>
        </div>
        <ToastContainer />

        <div
          className="modal fade tb-modal"
          id="editProductModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="kd-inv-edit-title"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title" id="kd-inv-edit-title">
                  Update product
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="kd-inv-name">Product name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="productName"
                    onChange={this.handleChange}
                    value={this.state.productName}
                    id="kd-inv-name"
                    placeholder="Enter product name"
                  />
                </div>

                <div className="kd-ws-form-grid">
                  <div className="form-group">
                    <label htmlFor="kd-inv-qty">Quantity</label>
                    <input
                      type="text"
                      className="form-control"
                      name="quantity"
                      onChange={this.handleChange}
                      value={this.state.quantity}
                      id="kd-inv-qty"
                      placeholder="Enter quantity"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kd-inv-amount">Total price (Tk)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="amount"
                      value={this.state.amount}
                      onChange={this.handleChange}
                      id="kd-inv-amount"
                      placeholder="in taka"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="kd-inv-details">Order details</label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="details"
                    onChange={this.handleChange}
                    value={this.state.details}
                    id="kd-inv-details"
                    placeholder="Size, color, variants etc"
                  />
                </div>

                <div className="kd-ws-form-grid">
                  <div className="form-group">
                    <label htmlFor="kd-inv-status">Order status</label>
                    <select
                      id="kd-inv-status"
                      title="Please choose a status"
                      required
                      name="orderStatus"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.orderStatus}
                    >
                      <option value="">Select status</option>
                      <option value={`Ordered`}>Ordered</option>
                      <option value={`Not Ordered`}>Not Ordered</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="kd-inv-track">Tracking no</label>
                    <input
                      type="text"
                      className="form-control"
                      name="trackingNo"
                      value={this.state.trackingNo}
                      onChange={this.handleChange}
                      id="kd-inv-track"
                      placeholder="Enter tracking no"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kd-inv-store">Order store</label>
                    <input
                      type="text"
                      className="form-control"
                      name="orderStore"
                      value={this.state.orderStore}
                      onChange={this.handleChange}
                      id="kd-inv-store"
                      placeholder="1688/taobao/ebay/flipkart"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kd-inv-orderid">Order ID</label>
                    <input
                      type="text"
                      className="form-control"
                      name="orderId"
                      value={this.state.orderId}
                      onChange={this.handleChange}
                      id="kd-inv-orderid"
                      placeholder="Ex: 1688 order Id"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.handleUpdate(sourcingObj, this.state.productObj);
                  }}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade tb-modal"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="kd-inv-add-title"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title" id="kd-inv-add-title">
                  Add products
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.productsArray.length === 0 && (
                  <div className="consultancy-packing-empty">
                    <EmptyState>No products added yet.</EmptyState>
                  </div>
                )}
                {this.state.productsArray.map((product, index) => {
                  return (
                    <div className="consultancy-packing-row" key={product.id}>
                      <div className="consultancy-packing-row-image">
                        {this.state.image_loader ? (
                          <div
                            className="spinner-border mt-3 ml-4"
                            role="status"
                            style={{ width: 20, height: 20 }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <>
                            <img
                              src={product.imageUrl}
                              alt=""
                              title="Choose a photo"
                              onClick={() => {
                                document
                                  .getElementById(
                                    `upload-image-input${index}`,
                                  )
                                  .click();
                              }}
                            />
                            <input
                              id={`upload-image-input${index}`}
                              type="file"
                              accept="image/*"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                this._handleImgChange(e, index);
                              }}
                            />
                          </>
                        )}
                      </div>
                      <input
                        type="text"
                        className="form-control consultancy-packing-input"
                        placeholder="Product name"
                        aria-label="Product name"
                        value={product.productName}
                        onChange={(e) => {
                          const { value } = e.target;
                          this.setState({
                            productsArray: this.state.productsArray.map(
                              (product2) =>
                                product2.id === product.id
                                  ? { ...product2, productName: value }
                                  : product2,
                            ),
                          });
                        }}
                      />
                      <input
                        type="text"
                        className="form-control consultancy-packing-input consultancy-packing-input--num"
                        placeholder="Quantity"
                        aria-label="Quantity"
                        value={product.quantity}
                        onChange={(e) => {
                          const { value } = e.target;
                          this.setState({
                            productsArray: this.state.productsArray.map(
                              (product2) =>
                                product2.id === product.id
                                  ? { ...product2, quantity: value }
                                  : product2,
                            ),
                          });
                        }}
                      />
                      <input
                        type="text"
                        className="form-control consultancy-packing-input"
                        placeholder="Size, color, variants etc"
                        aria-label="Details"
                        value={product.details}
                        onChange={(e) => {
                          const { value } = e.target;
                          this.setState({
                            productsArray: this.state.productsArray.map(
                              (product2) =>
                                product2.id === product.id
                                  ? { ...product2, details: value }
                                  : product2,
                            ),
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="consultancy-packing-row-remove"
                        title="Remove this product"
                        aria-label="Remove this product"
                        onClick={() => {
                          this.setState({
                            productsArray: this.state.productsArray.filter(
                              (product2) => product2.id !== product.id,
                            ),
                          });
                        }}
                      >
                        <X size={15} aria-hidden="true" />
                      </button>
                    </div>
                  );
                })}

                <button
                  type="button"
                  className="consultancy-packing-add-row-btn"
                  onClick={() => {
                    this.setState({
                      productsArray: [
                        ...this.state.productsArray,
                        {
                          id:
                            new Date().getTime() +
                            this.state.productsArray.length,
                          imageUrl: man,
                          productName: "",
                          quantity: "",
                          details: "",
                        },
                      ],
                    });
                  }}
                >
                  <Plus size={15} aria-hidden="true" />
                  Add another product
                </button>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Add products
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade tb-modal"
          id="deleteExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="kd-inv-del-title"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title" id="kd-inv-del-title">
                  Delete product
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p className="kd-inv-confirm">
                  Are you sure you want to delete this product from the invoice?
                </p>
                <div className="kd-inv-del-card">
                  <img
                    className="lazyloaded blur-up"
                    src={(productObj && productObj.imageUrl) || man}
                    alt=""
                  />
                  <div>
                    <strong>{productObj && productObj.productName}</strong>
                    <small>
                      Quantity {productObj && productObj.quantity}
                    </small>
                    <small className="kd-muted">ID {productObj && productObj.id}</small>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  No, keep it
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.deleteSourcingProductRedux(
                      sourcingObj.id,
                      productObj.id
                    );
                  }}
                >
                  Yes, delete
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade tb-modal"
          id="receiveModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="kd-inv-recv-title"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title" id="kd-inv-recv-title">
                  Receive in warehouse
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="kd-inv-warehouse">Receiving in warehouse</label>
                  <select
                    id="kd-inv-warehouse"
                    title="Please choose a warehouse"
                    required
                    name="warehouse"
                    className="custom-select"
                    aria-required="true"
                    aria-invalid="false"
                    onChange={this.handleChange}
                    value={this.state.warehouse}
                  >
                    <option value="">Select warehouse</option>
                    <option value="Bangladesh warehouse">Bangladesh</option>
                    <option value="India warehouse">India</option>
                    <option value="USA warehouse">USA</option>
                    <option value="China warehouse">China</option>
                    <option value="Dubai warehouse">Dubai</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.handleReceive();
                  }}
                >
                  Receive
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    users: state.users.users,
    currentAdmin: state.admins.currentAdmin,
    sourcingObj: state.sourcings.sourcingObj,
  };
};

export default connect(mapStateToProps, {
  getSingleSourcingRedux,
  updateSourcingRedux,
  deleteSourcingProductRedux,
})(ProductDetails);
